import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  notifications: [],
  error: null
};

const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    fetchNotificationsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchNotificationsSuccess: (state, action) => {
      state.loading = false;
      state.notifications = action.payload;
    },
    fetchNotificationsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    markNotificationAsRead: (state, action) => {
      state.notifications = state.notifications.map((notification) =>
        notification.id === action.payload ? { ...notification, isRead: true } : notification
      );
    },
    markAllAsRead: (state) => {
      state.notifications = state.notifications.map((notification) => ({ ...notification, isRead: true }));
    },
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter((notification) => notification.id !== action.payload);
    },
  },
});

// Export the actions generated by the slice
export const {
  fetchNotificationsRequest,
  fetchNotificationsSuccess,
  fetchNotificationsFailure,
  markNotificationAsRead,
  markAllAsRead,
  removeNotification
} = notificationSlice.actions;

// Export the reducer to be used in the store
export default notificationSlice.reducer;
